<app-auth-header [title]="'AUTH.TITLE' | translate"></app-auth-header>

<div class="saml-callback-container text-center">
  <!-- Loading State -->
  @if (!isError) {
    <div class="loading-state">
      <p-progressSpinner styleClass="custom-spinner" strokeWidth="3"></p-progressSpinner>
      <p class="loading-message">{{ 'AUTH.MESSAGES.COMPLETING_SSO_LOGIN' | translate }}</p>
    </div>
  }

  <!-- Error State -->
  @if (isError) {
    <div class="error-state">
      <i class="pi pi-times-circle error-icon"></i>
      <h3 class="error-title">{{ 'AUTH.ERRORS.SAML_LOGIN_FAILED.TITLE' | translate }}</h3>
      <p class="error-message">{{ errorMessage }}</p>
      <p class="redirect-message">{{ 'AUTH.MESSAGES.REDIRECTING_TO_LOGIN' | translate }}</p>
    </div>
  }
</div>
